<template>
    <div class="input bg-white/10 backdrop-blur px-2 py-3 mt-4"
         :class="data.results.length > 0 ? 'rounded-t-xl' : 'rounded-xl'">
        <input maxlength="25" v-model="data.category" @focusout="handleFocusOut" v-on:keydown="onEnter" type="text" id="tags" ref="inputTags" class="w-full text-sm rounded-base border-transparent outline-none focus:border-transparent focus:ring-0" placeholder="Tags" />
        <button @click="addTag" type="button" class="absolute end-1.5 bottom-2 text-white hover:bg-brand-strong shadow-xs font-medium leading-5 rounded text-xs px-3 py-1.5 focus:outline-none hover:bg-white/10">+</button>
    </div>
    <div class="px-3 bg-white/10 rounded-b-xl pb-3" v-if="data.results.length > 0">
        <div class="text-sm font-medium ms-2 pb-1">Suggested Categories</div>
        <select v-model="data.dummy" :size="data.results.length < 5 ? data.results.length + 1 : 4" class="w-full pb-1 px-2 bg-white/10 rounded-lg text-sm border border-white/20 focus:outline-none focus:ring-2 focus:ring-white-400">
            <option disabled value="a"></option>
            <option class="pb-1" selected="false" @click="selectResult(result)" v-for="result in data.results" :key="result">{{ result }}</option>
        </select>
    </div>
    <div class="mt-3">
        <div v-for="(value, index) in data.tags" :key="index" class="flex float-left px-2 py-1 me-2 mb-2 bg-blue-300 text-black rounded">
            <span>{{ value }}</span>
            <span class=" m-auto ms-1 rounded hover:bg-white" @click="removeTag(index)">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/></svg>
            </span>
        </div>
    </div>
</template>
<script lang="ts">
    import { onMounted, reactive, ref, watch } from "vue"
    import categoryService from "@/services/category.service";
    const inputTags = ref();

    export default {
        name: 'TagsComponent',
        props: ["tags"],
        setup(props: any) {
            const data = reactive({
                tags: [] as string[],
                searching: 0 as number,
                category: "" as string,
                results: [] as string[],
                dummy: ""
            })

            watch(() => data.category,
                (value) => {
                    clearTimeout(data.searching || 0);
                    if (value && value.length > 0) {
                        data.searching = setTimeout(() => search(value), 2000) || 0;
                    }
                    
                }
            )

            watch(() => props.tags,
                (value, _) => {
                    if (value) {
                        data.tags = value;
                    } 
                }
            );

            onMounted(() => {
                data.tags = props.tags;
            })

            const addTag = () => {
                const value = data.category ?? "";
                addTagValue(value);
            }

            const addTagValue = (value: string) => {
                try
                {
                    if (!data.tags) {
                        data.tags = [];
                    }
                    if (value.length > 0 && (data.tags.indexOf(value) == -1)) {
                        data.tags.push(value);
                        data.category = "";
                        if (inputTags.value)
                        inputTags.value.focus();
                    }
                    data.results = [];          
                } catch (error) {
                    console.log("Problem adding tag: ", error)
                }
            }

            const removeTag = (index: number) => {
                data.tags.splice(index, 1)
            }

            const selectResult = (result: string) => {
                console.debug("selectResult", result)
                addTagValue(result);
                data.results = [];
            }

            const onEnter = (e: any) => {
                if (e.key === 'Enter') {
                    console.debug("onEnter")
                    e.preventDefault()
                    addTag()
                }
            }

            const handleFocusOut = () => {
                data.category = "";
            }
            const search = async (value: string) => {
                if (value.length == 0) {
                    data.results = [];
                } else  {
                    const response = await categoryService.getSearch(0, 5, data.category);
                    
                    if (response && response.data && response.data.data) {
                        const items = response.data.data;
                        data.results = [];
                        items.forEach(element => {
                            data.results.push(element.name);
                        });
                        //data.category = "";
                    }                    
                }
            }

            return { data, addTag, removeTag, selectResult, onEnter, search, handleFocusOut }
        }
    }
    
</script>